const normalizeValue = (value: number) => Math.max(value, 0)

export const useProgressBar = (
  healthy: number,
  warning: number,
  broken: number
) => {
  const segments = [
    {
      id: 'healthy',
      value: normalizeValue(healthy),
    },
    {
      id: 'warning',
      value: normalizeValue(warning),
    },
    {
      id: 'broken',
      value: normalizeValue(broken),
    },
  ]

  const total = segments.reduce((sum, segment) => sum + segment.value, 0)
  const visibleSegments = segments.filter((segment) => segment.value > 0)
  const getWidth = (value: number) => `${(value / total) * 100}%`

  return {
    visibleSegments,
    getWidth,
  }
}
